import Select from 'react-select';
import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import PreviewDoc from '../../components/PreviewDoc';

function NewAccommodation() {
  const social_networks = [
    { id: 1, name: 'facebook' },
    { id: 2, name: 'instagram' },
    { id: 3, name: 'whatsapp' },
  ];

  const { token } = useContext(AuthContext);

  const { id: currentId } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const [successSaved, setSuccessSaved] = useState(false);

  const [errorSave, setErrorSave] = useState(false);
  const [errorSaveMessage, setErrorSaveMessage] = useState('');
  const [successSave, setSuccessSave] = useState(false);
  const [successSaveMessage, setSuccessSaveMessage] = useState('');

  const [currentAccommodation, setCurrentAccommodation] = useState({});
  const [currentImages, setCurrentImages] = useState([]);
  const [currentMainImageUrl, setCurrentMainImageUrl] = useState('');

  const [countriesOptions, setCountriesOptions] = useState([]);
  const [regionsOptions, setRegionsOptions] = useState([]);
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [subwayOptions, setSubwayOptions] = useState([]);
  const [allRegions, setAllRegions] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedDescriptionEs, setSelectedDescriptionEs] = useState('');
  const [selectedDescriptionEn, setSelectedDescriptionEn] = useState('');

  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedTitleEs, setSelectedTitleEs] = useState('');
  const [selectedTitleEn, setSelectedTitleEn] = useState('');
  const [selectedMapPosition, setSelectedMapPosition] = useState('');
  const [selectedRooms, setSelectedRooms] = useState(1);
  const [selectedRating, setSelectedRating] = useState(5);
  const [selectedFurnished, setSelectedFurnished] = useState('2');
  const [selectedBathrooms, setSelectedBathrooms] = useState(1);
  const [selectedSubway, setSelectedSubway] = useState(null);
  const [selectedServices, setSelectedServices] = useState([
    { id: 1, name: 'Cocina', checked: false },
    { id: 2, name: 'Piscina', checked: false },
    { id: 3, name: 'Internet', checked: false },
    { id: 4, name: 'Lavandería', checked: false },
    { id: 5, name: 'Agua', checked: false },
    { id: 6, name: 'Tv', checked: false },
    { id: 7, name: 'Luz', checked: false },
    { id: 8, name: 'Limpieza', checked: false },
    { id: 9, name: 'Gas', checked: false },
  ]);
  const [selectedContact, setSelectedContact] = useState({
    name: '',
    address: '',
    phone: '',
    email: '',
  });
  const [selectedWebsite, setSelectedWebsite] = useState('');
  const [selectedSocialNetworks, setSelectedSocialNetworks] = useState({
    facebook: '',
    instagram: '',
    whatsapp: '',
  });
  const [selectedImages, setSelectedImages] = useState(null);

  const [selectedDocuments, setSelectedDocuments] = useState({});

  // expired documents
  const [path_erut_expired, setPathErutExpired] = useState(false);
  const [path_te1_expired, setPathTe1Expired] = useState(false);
  const [path_sello_verde_expired, setPathSelloVerdeExpired] = useState(false);
  const [path_seremi_expired, setPathSeremiExpired] = useState(false);
  const [path_patente_expired, setPathPatenteExpired] = useState(false);
  const [path_contrato_expired, setPathContratoExpired] = useState(false);

  // na documents
  const [path_erut_na, setPathErutNA] = useState(false);
  const [path_te1_na, setPathTe1NA] = useState(false);
  const [path_sello_verde_na, setPathSelloVerdeNA] = useState(false);
  const [path_seremi_na, setPathSeremiNA] = useState(false);
  const [path_patente_na, setPathPatenteNA] = useState(false);
  const [path_contrato_na, setPathContratoNA] = useState(false);

  const getRegions = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/es/regions`);
    const { regions: data } = response.data;

    const regionsAndCities = data.map(region => ({
      value: region.id,
      label: region.name,
      country_id: region.country ? region.country.id : null,
      cities: region.cities.map(city => ({
        value: city.id,
        label: city.name,
      })),
      subways: region.subways.map(subway => ({
        value: subway.id,
        label: subway.name,
      })),
    }));
    setAllRegions(regionsAndCities);
    return regionsAndCities;
  };

  const getCountries = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/es/countries`);
    const options = response.data.countries.map(c => ({
      value: c.id,
      label: c.name,
      abbreviation: c.abbreviation,
    }));
    setCountriesOptions(options);
    return options;
  };

  const handleDeleteDoc = doc => async () => {
    const confirm = window.confirm('¿Estás seguro de eliminar el documento?');
    if (!confirm) return;

    const lang = 'es';

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/api/${lang}/accommodations/${currentId}/documents/${doc}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          },
        }
      );

      if (response.status === 200) {
        window.location.reload();
      }
    } catch (error) {
      const msg = extractErrorMessage(error);
      setErrorSave(true);
      setErrorSaveMessage(msg);
      setIsLoading(false);
    }
  };

  const handleDeleteImage = image_id => async () => {
    // show confirm dialog before delete
    const confirm = window.confirm('¿Estás seguro de eliminar la imagen?');
    if (!confirm) return;

    const lang = 'es';

    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/api/${lang}/accommodations/${currentId}/images/${image_id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          },
        }
      );

      if (response.status === 200) {
        window.location.reload();
        // TODO: cambiar por refresco de información
      }
    } catch (error) {
      const msg = extractErrorMessage(error);
      setErrorSave(true);
      setErrorSaveMessage(msg);
      setIsLoading(false);
    }
  };

  const handleMainImageChange = image_url => async () => {
    setErrorSave(false);
    setSuccessSave(false);
    setIsLoading(true);
    const lang = 'es';

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/${lang}/accommodations/${currentId}/main_image`,
        { main_image: image_url },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          },
        }
      );

      if (response.status === 200) {
        setSuccessSave(true);
        setSuccessSaveMessage(response.data.message);
        setCurrentMainImageUrl(response.data.main_image);
        setCurrentImages(response.data.images);
        setIsLoading(false);
      } else {
        setErrorSave(true);
        setErrorSaveMessage('Ups!');
        setIsLoading(false);
      }
    } catch (error) {
      const msg = extractErrorMessage(error);
      setErrorSave(true);
      setErrorSaveMessage(msg);
      setIsLoading(false);
    }
  };

  const handleServicesChange = (e, id) => {
    const updatedServices = selectedServices.map(service => {
      if (service.id === id) {
        return { ...service, checked: !service.checked };
      }
      return service;
    });
    setSelectedServices(updatedServices);
  };

  const handleCountryChange = selectedOption => {
    setSelectedCountry(selectedOption);
    setSelectedCity(null);
    setSelectedRegion(null);
    setSelectedSubway(null);
    setCitiesOptions([]);
    setSubwayOptions([]);

    const filteredRegions = allRegions.filter(r => r.country_id === selectedOption.value);
    setRegionsOptions(filteredRegions);
  };

  const handleRegionChange = selectedOption => {
    if (selectedOption.cities.length === 0) {
      setSelectedCity(null);
    }

    setSelectedRegion(selectedOption);

    setCitiesOptions(selectedOption.cities);
    setSubwayOptions(selectedOption.subways);
  };

  const extractErrorMessage = (
    error,
    defaultMessage = 'Ha ocurrido un error inesperado al guardar los cambios'
  ) => {
    if (!error) return defaultMessage;
    if (error.response) {
      const data = error.response.data;
      if (typeof data === 'string') {
        if (data.includes('<pre>')) {
          const match = data.match(/<pre>([\s\S]*?)<\/pre>/i);
          return match
            ? match[1]
                .replace(/<br\s*[\/]?>/gi, ' ')
                .split('\n')[0]
                .trim()
            : `Error ${error.response.status}`;
        }
        if (!data.trim().startsWith('<')) {
          return data;
        }
        return `Error del servidor (${error.response.status}: ${error.response.statusText || 'Error desconocido'})`;
      }
      if (data && typeof data === 'object') {
        if (data.error && typeof data.error === 'string') return data.error;
        if (data.message && typeof data.message === 'string') return data.message;
        if (Array.isArray(data.errors) && data.errors.length > 0) {
          return data.errors
            .map(e => (typeof e === 'object' ? e.message || JSON.stringify(e) : e))
            .join(', ');
        }
        if (data.msg && typeof data.msg === 'string') return data.msg;
      }
    }
    if (error.message && typeof error.message === 'string') {
      return error.message;
    }
    return defaultMessage;
  };

  const selectedDocument = (name, files) => {
    setErrorSave(false);
    setSuccessSave(false);
    if (!files || files.length === 0) {
      return;
    }

    if (files[0].type !== 'application/pdf') {
      setErrorSave(true);
      const inputEl = document.getElementById(name);
      if (inputEl) inputEl.value = '';
      setErrorSaveMessage('Solo se permiten archivos PDF');
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5MB
    if (files[0].size > maxSize) {
      setErrorSave(true);
      const inputEl = document.getElementById(name);
      if (inputEl) inputEl.value = '';
      setErrorSaveMessage(`El archivo "${files[0].name}" excede el tamaño máximo permitido de 5MB`);
      return;
    }

    setSelectedDocuments({ ...selectedDocuments, [name]: files });
  };

  const handleImagesChange = e => {
    setErrorSave(false);
    setSuccessSave(false);
    const files = e.target.files;
    if (!files || files.length === 0) {
      return;
    }

    if (files.length > 10) {
      setErrorSave(true);
      e.target.value = '';
      setErrorSaveMessage('Se permite un máximo de 10 imágenes');
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5MB
    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];

    for (let i = 0; i < files.length; i++) {
      if (!files[i].type.startsWith('image/')) {
        setErrorSave(true);
        e.target.value = '';
        setErrorSaveMessage('Solo se permiten archivos de imagen');
        return;
      }
      if (!allowedTypes.includes(files[i].type)) {
        setErrorSave(true);
        e.target.value = '';
        setErrorSaveMessage(
          `Formato de "${files[i].name}" no compatible. Solo se permiten imágenes JPEG, PNG o WEBP.`
        );
        return;
      }
      if (files[i].size > maxSize) {
        setErrorSave(true);
        e.target.value = '';
        setErrorSaveMessage(
          `La imagen "${files[i].name}" excede el tamaño máximo permitido de 5MB`
        );
        return;
      }
    }

    setSelectedImages(files);
  };

  const handleSaveAccommodation = async () => {
    setErrorSave(false);
    setSuccessSave(false);
    setIsLoading(true);
    const lang = 'es';

    const services = JSON.stringify(selectedServices);
    const contact = JSON.stringify(selectedContact);
    const social_networks = JSON.stringify(selectedSocialNetworks);

    if (!selectedTitleEs || !selectedTitleEn || !selectedCountry) {
      setErrorSave(true);
      setErrorSaveMessage('Título (en y es) y País son requeridos');
      setIsLoading(false);
      return;
    }

    if (selectedCountry.abbreviation === 'CL' && !selectedCity) {
      setErrorSave(true);
      setErrorSaveMessage('Ciudad es requerida para Chile');
      setIsLoading(false);
      return;
    }

    const data = {
      country_id: selectedCountry.value,
      city_id: selectedCity ? selectedCity.value : null,
      title_es: selectedTitleEs,
      title_en: selectedTitleEn,
      description_es: selectedDescriptionEs,
      description_en: selectedDescriptionEn,
      rating: selectedRating,
      rooms: selectedRooms,
      furnished: selectedFurnished,
      bathrooms: selectedBathrooms,
      closest_subway: selectedSubway ? selectedSubway.value : null,
      services,
      contact,
      website: selectedWebsite,
      map_position: selectedMapPosition,
      social_networks,
      path_erut_expired,
      path_te1_expired,
      path_sello_verde_expired,
      path_seremi_expired,
      path_patente_expired,
      path_contrato_expired,
      path_erut_na,
      path_te1_na,
      path_sello_verde_na,
      path_seremi_na,
      path_patente_na,
      path_contrato_na,
    };

    const formData = new FormData();
    formData.append('data', JSON.stringify(data));

    // images
    if (selectedImages) {
      for (let i = 0; i < selectedImages.length; i++) {
        formData.append('images', selectedImages[i]);
      }
    }

    // documents
    if (selectedDocuments.path_erut) {
      formData.append('path_erut', selectedDocuments.path_erut[0]);
    }
    if (selectedDocuments.path_te1) {
      formData.append('path_te1', selectedDocuments.path_te1[0]);
    }
    if (selectedDocuments.path_sello_verde) {
      formData.append('path_sello_verde', selectedDocuments.path_sello_verde[0]);
    }
    if (selectedDocuments.path_seremi) {
      formData.append('path_seremi', selectedDocuments.path_seremi[0]);
    }
    if (selectedDocuments.path_patente) {
      formData.append('path_patente', selectedDocuments.path_patente[0]);
    }
    if (selectedDocuments.path_contrato) {
      formData.append('path_contrato', selectedDocuments.path_contrato[0]);
    }

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/${lang}/accommodations/${currentId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        setSuccessSave(true);
        setSuccessSaveMessage(response.data.message || 'Alojamiento actualizado correctamente');
        setSuccessSaved(true);
        setIsLoading(false);
      } else {
        setErrorSave(true);
        setErrorSaveMessage('No se pudo actualizar el alojamiento');
      }
    } catch (error) {
      const msg = extractErrorMessage(error);
      setErrorSave(true);
      setErrorSaveMessage(msg);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      // window.location.href = '/';
    }

    const fetchData = async () => {
      try {
        const [countries, regions] = await Promise.all([getCountries(), getRegions()]);
        await getCurrentAccommodation(countries, regions);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsFetching(false);
      }
    };

    fetchData();
  }, [token]);

  // actualizar listado de ciudades cuando cambie la region
  useEffect(() => {
    if (selectedRegion) {
      setCitiesOptions(selectedRegion.cities);
      setSubwayOptions(selectedRegion.subways);
    }
  }, [selectedRegion]);

  const getCurrentAccommodation = async (countries, regions) => {
    const lang = 'es';
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/es/accommodations/${currentId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    const { data } = await response;

    // Set current accommodation
    setSelectedTitleEs(data.title_es || '');
    setSelectedTitleEn(data.title_en || '');
    setSelectedRating(data.rating || 5);
    setSelectedDescriptionEs(data.description_es || '');
    setSelectedDescriptionEn(data.description_en || '');
    setSelectedRooms(data.rooms || 1);
    setSelectedFurnished(data.furnished == true ? '1' : '2');
    setSelectedBathrooms(data.bathrooms || 1);
    setSelectedWebsite(data.website || '');
    setSelectedMapPosition(data.map_position || '');
    setCurrentMainImageUrl(data.main_image || '');

    // set services
    if (data.services) {
      const tempCurrentServices = selectedServices.map(service => {
        if (data.services[service.name.toLowerCase()] == true) {
          return { ...service, checked: true };
        }
        return service;
      });
      setSelectedServices(tempCurrentServices);
    }

    // set contacto and rrss
    if (data.social_networks) {
      const { facebook = '', instagram = '', whatsapp = '' } = data.social_networks;
      setSelectedSocialNetworks({ facebook, instagram, whatsapp });
    }

    if (data.contact) {
      const { name = '', address = '', phone = '', email = '' } = data.contact;
      setSelectedContact({ name, address, phone, email });
    }

    setCurrentAccommodation(data);

    // set images
    setCurrentImages(data.images);

    // set country
    if (data.country_id && countries) {
      const country = countries.find(c => c.value === data.country_id);
      setSelectedCountry(country);

      if (country && regions) {
        const filteredRegions = regions.filter(r => r.country_id === country.value);
        setRegionsOptions(filteredRegions);
      }
    } else if (data.region && data.region.country_id && countries) {
      const country = countries.find(c => c.value === data.region.country_id);
      if (country) {
        setSelectedCountry(country);
        if (regions) {
          const filteredRegions = regions.filter(r => r.country_id === country.value);
          setRegionsOptions(filteredRegions);
        }
      } else {
        // Fallback to Chile if country_id from region not found
        const chile = countries.find(c => c.abbreviation === 'CL');
        if (chile) {
          setSelectedCountry(chile);
          if (regions) {
            const filteredRegions = regions.filter(r => r.country_id === chile.value);
            setRegionsOptions(filteredRegions);
          }
        }
      }
    } else if (countries) {
      // Default to Chile if country_id is not set
      const chile = countries.find(c => c.abbreviation === 'CL');
      if (chile) {
        setSelectedCountry(chile);
        if (regions) {
          const filteredRegions = regions.filter(r => r.country_id === chile.value);
          setRegionsOptions(filteredRegions);
        }
      }
    }

    // set region
    if (data.region && data.region.region_id && regions) {
      const region = regions.find(r => r.value === data.region.region_id);
      setSelectedRegion(region || null);
      if (region && region.cities) {
        setCitiesOptions(region.cities);
        setSubwayOptions(region.subways);

        // set city
        if (data.city && data.city.id) {
          const city = region.cities.find(c => c.value === data.city.id);
          setSelectedCity(city || null);
        } else {
          setSelectedCity(null);
        }
      } else {
        setSelectedCity(null);
      }
    } else {
      setSelectedRegion(null);
      setSelectedCity(null);
    }
    // set subway
    if (data.closest_subway) {
      setSelectedSubway(data.closest_subway);
    } else {
      setSelectedSubway(null);
    }

    // set expired documents
    setPathErutExpired(data.path_erut_expired);
    setPathTe1Expired(data.path_te1_expired);
    setPathSelloVerdeExpired(data.path_sello_verde_expired);
    setPathSeremiExpired(data.path_seremi_expired);
    setPathPatenteExpired(data.path_patente_expired);
    setPathContratoExpired(data.path_contrato_expired);

    // set na documents
    setPathErutNA(data.path_erut_na);
    setPathTe1NA(data.path_te1_na);
    setPathSelloVerdeNA(data.path_sello_verde_na);
    setPathSeremiNA(data.path_seremi_na);
    setPathPatenteNA(data.path_patente_na);
    setPathContratoNA(data.path_contrato_na);
  };

  return (
    <>
      <div className="container">
        <h1 className="my-3">Edit Accommodation</h1>
        {isFetching ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
          </div>
        ) : (
          <div className="row">
            <div className="shadow p-3 mb-3 rounded border" id="region_city_section">
              <div className="row">
                <div className="col-4">
                  <label htmlFor="country" className="col-form-label">
                    País <span className="text-danger">*</span>
                  </label>
                  <div className="">
                    <Select
                      id="country"
                      name="country"
                      aria-label="Default select example"
                      options={countriesOptions}
                      value={selectedCountry}
                      onChange={handleCountryChange}
                    />
                  </div>
                </div>
                {selectedCountry && selectedCountry.abbreviation === 'CL' && (
                  <>
                    <div className="col-4">
                      <label htmlFor="region" className="col-form-label">
                        Región
                      </label>
                      <div className="">
                        <Select
                          id="region"
                          name="region"
                          aria-label="Default select example"
                          options={regionsOptions}
                          value={selectedRegion}
                          onChange={handleRegionChange}
                        />
                      </div>
                    </div>
                    <div className="col-4">
                      <label htmlFor="city" className="col-form-label">
                        Ciudad <span className="text-danger">*</span>
                      </label>
                      <div className="">
                        <Select
                          id="city"
                          name="city"
                          aria-label="Default select example"
                          options={citiesOptions}
                          value={selectedCity}
                          onChange={selectedOption => setSelectedCity(selectedOption)}
                        />
                      </div>
                    </div>
                    <div className="col-4 mt-3">
                      <label htmlFor="closest_subway" className="col-form-label">
                        Metro más cercano
                      </label>
                      <div className="">
                        <Select
                          id="closest_subway"
                          name="closest_subway"
                          aria-label="Default select example"
                          options={subwayOptions}
                          value={selectedSubway}
                          onChange={selectedOption => setSelectedSubway(selectedOption)}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="shadow p-3 mb-3 rounded border" id="title_section">
              <div className="row">
                {/* rooms */}
                <div className="col-3">
                  <label htmlFor="rooms" className="col-form-label">
                    Habitaciones
                  </label>
                  <div className="">
                    <input
                      type="number"
                      className="form-control"
                      id="rooms"
                      name="rooms"
                      value={selectedRooms}
                      onChange={e => setSelectedRooms(e.target.value)}
                    />
                  </div>
                </div>
                {/* rating */}
                <div className="col-3">
                  <label htmlFor="rating" className="col-form-label">
                    Calificación
                  </label>
                  <div className="">
                    <input
                      type="number"
                      step="0.5"
                      min="1"
                      max="5"
                      className="form-control"
                      id="rating"
                      name="rating"
                      value={selectedRating}
                      onChange={e => setSelectedRating(e.target.value)}
                    />
                  </div>
                </div>
                {/* furnished */}
                <div className="col-3">
                  <label htmlFor="furnished" className="col-form-label">
                    Amoblado?
                  </label>
                  <div className="">
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="furnished-yes"
                        name="furnished"
                        value="1"
                        checked={selectedFurnished === '1'}
                        onChange={e => setSelectedFurnished(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="furnished-yes">
                        Sí
                      </label>
                    </div>
                    <div className="form-check form-check-inline">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="furnished-no"
                        name="furnished"
                        value="2"
                        checked={selectedFurnished === '2'}
                        onChange={e => setSelectedFurnished(e.target.value)}
                      />
                      <label className="form-check-label" htmlFor="furnished-no">
                        No
                      </label>
                    </div>
                  </div>
                </div>
                {/* bathrooms */}
                <div className="col-3">
                  <label htmlFor="bathrooms" className="col-form-label">
                    Baños
                  </label>
                  <div className="">
                    <input
                      type="number"
                      className="form-control"
                      id="bathrooms"
                      name="bathrooms"
                      value={selectedBathrooms}
                      onChange={e => setSelectedBathrooms(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-6">
                  <label htmlFor="title_es" className="col-form-label">
                    Nombre [es] <span className="text-danger">*</span>
                  </label>
                  <div className="">
                    <input
                      type="text"
                      className="form-control"
                      id="title_es"
                      name="title_es"
                      value={selectedTitleEs}
                      onChange={e => setSelectedTitleEs(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label htmlFor="title_en" className="col-form-label">
                    Nombre [en] <span className="text-danger">*</span>
                  </label>
                  <div className="">
                    <input
                      type="text"
                      className="form-control"
                      id="title_en"
                      name="title_en"
                      value={selectedTitleEn}
                      onChange={e => setSelectedTitleEn(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-6">
                  <label htmlFor="description_es" className="col-form-label">
                    Descripción [es]
                  </label>
                  <div className="">
                    <textarea
                      className="form-control"
                      id="description_es"
                      name="description_es"
                      rows="3"
                      onChange={e => setSelectedDescriptionEs(e.target.value)}
                      value={selectedDescriptionEs}
                    />
                  </div>
                </div>
                <div className="col-6">
                  <label htmlFor="description_en" className="col-form-label">
                    Descripción [en]
                  </label>
                  <div className="">
                    <textarea
                      className="form-control"
                      id="description_en"
                      name="description_en"
                      rows="3"
                      onChange={e => setSelectedDescriptionEn(e.target.value)}
                      value={selectedDescriptionEn}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="" id="services_section">
              <div className="row">
                {/* services */}
                <div className="col-4 ps-0">
                  <div className="shadow p-3 mb-3 rounded border">
                    <label htmlFor="services" className="col-form-label">
                      Servicios
                    </label>
                    <div className="row ms-1">
                      {selectedServices.map(service => (
                        <div className="mb-2 form-check col-12" key={service.id}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={service.name}
                            name={service.name}
                            value={service.id}
                            onChange={e => handleServicesChange(e, service.id)}
                            checked={service.checked ? true : false}
                          />
                          <label className="form-check-label" htmlFor={service.name}>
                            {service.name}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {/* contacto */}
                <div className="col-8 shadow p-3 mb-3 rounded border">
                  <label htmlFor="contact" className="col-form-label">
                    Contacto
                  </label>
                  <div className="row">
                    <div className="mb-2 col-7">
                      <label htmlFor="nombre" className="form-label">
                        Nombre
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="nombre"
                        name="nombre"
                        value={selectedContact.name}
                        onChange={e =>
                          setSelectedContact({
                            ...selectedContact,
                            name: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="clearfix"></div>
                    <div className="mb-2 col-7">
                      <label htmlFor="direccion" className="form-label">
                        Dirección
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="direccion"
                        name="direccion"
                        value={selectedContact.address}
                        onChange={e =>
                          setSelectedContact({
                            ...selectedContact,
                            address: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mb-2 col-5">
                      <label htmlFor="map_position" className="form-label">
                        Coordenadas Mapa
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="map_position"
                        name="map_position"
                        value={selectedMapPosition}
                        onChange={e => setSelectedMapPosition(e.target.value)}
                      />
                    </div>
                    <div className="col-4">
                      <label htmlFor="telefono" className="form-label">
                        Teléfono
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        id="telefono"
                        name="telefono"
                        value={selectedContact.phone}
                        onChange={e =>
                          setSelectedContact({
                            ...selectedContact,
                            phone: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="col-4">
                      <label htmlFor="email" className="form-label">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={selectedContact.email}
                        onChange={e =>
                          setSelectedContact({
                            ...selectedContact,
                            email: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="col-4">
                      <label htmlFor="web" className="form-label">
                        Web
                      </label>
                      <input
                        type="url"
                        className="form-control"
                        id="web"
                        name="web"
                        value={selectedWebsite}
                        onChange={e => setSelectedWebsite(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="shadow p-3 mb-3 rounded border" id="rrss_section">
              <div className="row">
                {social_networks.map(social_network => (
                  <div className="col-4" key={social_network.id}>
                    <label htmlFor="{social_network.name}" className="form-label">
                      {social_network.name}
                      {social_network.name != 'whatsapp' ? (
                        <> (usuario sin @)</>
                      ) : (
                        <> (solo números, ej: 56912341234)</>
                      )}
                    </label>
                    <input
                      type="url"
                      className="form-control"
                      id="{social_network.name}"
                      name="{social_network.name}"
                      value={selectedSocialNetworks[social_network.name]}
                      onChange={e =>
                        setSelectedSocialNetworks({
                          ...selectedSocialNetworks,
                          [social_network.name]: e.target.value,
                        })
                      }
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* imagenes */}
            <div className="shadow p-3 mb-3 rounded border" id="images_section">
              <div className="row">
                <div className="col-12">
                  <label htmlFor="images" className="form-label">
                    Imágenes
                  </label>
                  <div className="row mb-2 px-1">
                    {currentImages &&
                      currentImages.map(image => (
                        <div className="col-2">
                          <div className="border bg-white p-2 mb-2" key={image.id}>
                            <div className="text-end">
                              {image.url === currentMainImageUrl ? (
                                <i className="fa fa-star text-warning mb-2"></i>
                              ) : (
                                <i
                                  className="fa fa-star text-secondary mb-2 cursor-pointer"
                                  onClick={handleMainImageChange(image.url)}
                                ></i>
                              )}
                            </div>
                            <img src={image.url} alt="" className="img-fluid" />
                            <button
                              type="button"
                              className="btn btn-sm btn-danger mt-2 w-100"
                              onClick={handleDeleteImage(image.id)}
                            >
                              Eliminar <i className="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                  </div>
                  <div className="row mx-1">
                    <input
                      className="form-control"
                      type="file"
                      id="images"
                      name="images"
                      accept="image/*"
                      multiple
                      onChange={handleImagesChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* documents */}
            <div className="shadow p-3 mb-3 rounded border" id="images_section">
              <div className="row">
                <div className="col-12">
                  <label htmlFor="documentos" className="form-label">
                    Documentos (PDF)
                  </label>
                  <div className="col-12">
                    <input
                      className="form-check-input me-1"
                      type="checkbox"
                      id="path_erut_na"
                      checked={path_erut_na}
                      onChange={e => setPathErutNA(e.target.checked)}
                    />
                    <label className="form-check-label me-2" htmlFor="path_erut_na">
                      N/A
                    </label>
                    <label htmlFor="path_erut" className="form-label">
                      Registro empresa
                    </label>
                    {currentAccommodation.path_erut && (
                      <>
                        <PreviewDoc
                          filePath={currentAccommodation.path_erut}
                          status="ok"
                          text="Vista Previa"
                        />
                        <i
                          className="fa fa-trash text-danger float-end cursor-pointer"
                          onClick={handleDeleteDoc('path_erut')}
                        ></i>
                        <input
                          className="form-check-input ms-3"
                          type="checkbox"
                          id="path_erut_expired"
                          checked={path_erut_expired}
                          onChange={e => setPathErutExpired(e.target.checked)}
                        />
                        <label className="form-check-label ms-1" htmlFor="path_erut_expired">
                          Vencido
                        </label>
                      </>
                    )}
                    <input
                      className="form-control"
                      type="file"
                      id="path_erut"
                      name="path_erut"
                      checked={path_erut_expired}
                      onChange={e => selectedDocument('path_erut', e.target.files)}
                    />
                  </div>
                  <div className="col-12 mt-3">
                    <input
                      className="form-check-input me-1"
                      type="checkbox"
                      id="path_te1_na"
                      checked={path_te1_na}
                      onChange={e => setPathTe1NA(e.target.checked)}
                    />
                    <label className="form-check-label me-2" htmlFor="path_te1_na">
                      N/A
                    </label>
                    <label htmlFor="path_te1" className="form-label">
                      Certificados
                    </label>
                    {currentAccommodation.path_te1 && (
                      <>
                        <PreviewDoc
                          filePath={currentAccommodation.path_te1}
                          status="ok"
                          text="Vista Previa"
                        />
                        <i
                          className="fa fa-trash text-danger float-end cursor-pointer"
                          onClick={handleDeleteDoc('path_te1')}
                        ></i>
                        <input
                          className="form-check-input ms-3"
                          type="checkbox"
                          id="path_te1_expired"
                          checked={path_te1_expired}
                          onChange={e => setPathTe1Expired(e.target.checked)}
                        />
                        <label className="form-check-label ms-1" htmlFor="path_te1_expired">
                          Vencido
                        </label>
                      </>
                    )}
                    <input
                      className="form-control"
                      type="file"
                      id="path_te1"
                      name="path_te1"
                      onChange={e => selectedDocument('path_te1', e.target.files)}
                    />
                  </div>
                  <div className="col-12 mt-3 d-none">
                    <input
                      className="form-check-input me-1"
                      type="checkbox"
                      id="path_sello_verde_na"
                      checked={path_sello_verde_na}
                      onChange={e => setPathSelloVerdeNA(e.target.checked)}
                    />
                    <label className="form-check-label me-2" htmlFor="path_sello_verde_na">
                      N/A
                    </label>
                    <label htmlFor="path_sello_verde" className="form-label">
                      Sello Verde
                    </label>
                    {currentAccommodation.path_sello_verde && (
                      <>
                        <PreviewDoc
                          filePath={currentAccommodation.path_sello_verde}
                          status="ok"
                          text="Vista Previa"
                        />
                        <i
                          className="fa fa-trash text-danger float-end cursor-pointer"
                          onClick={handleDeleteDoc('path_sello_verde')}
                        ></i>
                        <input
                          className="form-check-input ms-3"
                          type="checkbox"
                          id="path_sello_verde_expired"
                          checked={path_sello_verde_expired}
                          onChange={e => setPathSelloVerdeExpired(e.target.checked)}
                        />
                        <label className="form-check-label ms-1" htmlFor="path_sello_verde_expired">
                          Vencido
                        </label>
                      </>
                    )}
                    <input
                      className="form-control"
                      type="file"
                      id="path_sello_verde"
                      name="path_sello_verde"
                      onChange={e => selectedDocument('path_sello_verde', e.target.files)}
                    />
                  </div>
                  <div className="col-12 mt-3 d-none">
                    <input
                      className="form-check-input me-1"
                      type="checkbox"
                      id="path_seremi_na"
                      checked={path_seremi_na}
                      onChange={e => setPathSeremiNA(e.target.checked)}
                    />
                    <label className="form-check-label me-2" htmlFor="path_seremi_na">
                      N/A
                    </label>

                    <label htmlFor="path_seremi" className="form-label">
                      Seremi
                    </label>
                    {currentAccommodation.path_seremi && (
                      <>
                        <PreviewDoc
                          filePath={currentAccommodation.path_seremi}
                          status="ok"
                          text="Vista Previa"
                        />
                        <i
                          className="fa fa-trash text-danger float-end cursor-pointer"
                          onClick={handleDeleteDoc('path_seremi')}
                        ></i>
                        <input
                          className="form-check-input ms-3"
                          type="checkbox"
                          id="path_seremi_expired"
                          checked={path_seremi_expired}
                          onChange={e => setPathSeremiExpired(e.target.checked)}
                        />
                        <label className="form-check-label ms-1" htmlFor="path_seremi_expired">
                          Vencido
                        </label>
                      </>
                    )}
                    <input
                      className="form-control"
                      type="file"
                      id="path_seremi"
                      name="path_seremi"
                      onChange={e => selectedDocument('path_seremi', e.target.files)}
                    />
                  </div>
                  <div className="col-12 mt-3 d-none">
                    <input
                      className="form-check-input me-1"
                      type="checkbox"
                      id="path_patente_na"
                      checked={path_patente_na}
                      onChange={e => setPathPatenteNA(e.target.checked)}
                    />
                    <label className="form-check-label me-2" htmlFor="path_patente_na">
                      N/A
                    </label>

                    <label htmlFor="path_patente" className="form-label">
                      Patente
                    </label>
                    {currentAccommodation.path_patente && (
                      <>
                        <PreviewDoc
                          filePath={currentAccommodation.path_patente}
                          status="ok"
                          text="Vista Previa"
                        />
                        <i
                          className="fa fa-trash text-danger float-end cursor-pointer"
                          onClick={handleDeleteDoc('path_patente')}
                        ></i>
                        <input
                          className="form-check-input ms-3"
                          type="checkbox"
                          id="path_patente_expired"
                          checked={path_patente_expired}
                          onChange={e => setPathPatenteExpired(e.target.checked)}
                        />
                        <label className="form-check-label ms-1" htmlFor="path_patente_expired">
                          Vencido
                        </label>
                      </>
                    )}
                    <input
                      className="form-control"
                      type="file"
                      id="path_patente"
                      name="path_patente"
                      onChange={e => selectedDocument('path_patente', e.target.files)}
                    />
                  </div>
                  <div className="col-12 mt-3">
                    <input
                      className="form-check-input me-1"
                      type="checkbox"
                      id="path_contrato_na"
                      checked={path_contrato_na}
                      onChange={e => setPathContratoNA(e.target.checked)}
                    />
                    <label className="form-check-label me-2" htmlFor="path_contrato_na">
                      N/A
                    </label>

                    <label htmlFor="path_contrato" className="form-label">
                      Contrato
                    </label>
                    {currentAccommodation.path_contrato && (
                      <>
                        <PreviewDoc
                          filePath={currentAccommodation.path_contrato}
                          status="ok"
                          text="Vista Previa"
                        />
                        <i
                          className="fa fa-trash text-danger float-end cursor-pointer"
                          onClick={handleDeleteDoc('path_contrato')}
                        ></i>
                        <input
                          className="form-check-input ms-3"
                          type="checkbox"
                          id="path_contrato_expired"
                          checked={path_contrato_expired}
                          onChange={e => setPathContratoExpired(e.target.checked)}
                        />
                        <label className="form-check-label ms-1" htmlFor="path_contrato_expired">
                          Vencido
                        </label>
                      </>
                    )}
                    <input
                      className="form-control"
                      type="file"
                      id="path_contrato"
                      name="path_contrato"
                      onChange={e => selectedDocument('path_contrato', e.target.files)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="px-0 mt-2 mb-4 text-end">
              {errorSave && (
                <div
                  className="alert alert-danger cursor-pointer"
                  role="alert"
                  onClick={() => setSuccessSave(false)}
                >
                  {errorSaveMessage || 'Ha ocurrido un error al guardar los cambios'}
                </div>
              )}
              {successSave && (
                <div
                  className="alert alert-success cursor-pointer"
                  role="alert"
                  onClick={() => setSuccessSave(false)}
                >
                  {successSaveMessage}
                </div>
              )}

              {isLoading ? (
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <button type="button" onClick={handleSaveAccommodation} className="btn btn-dark">
                  Guardar
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default NewAccommodation;
